// NOTE: This require will be replaced with `@sentry/browser` when
// process.browser === true thanks to the webpack config in next.config.js
import * as Sentry from "@sentry/node";
import * as util from "./util";

/**
 * Adapted from https://github.com/getsentry/sentry-fullstory v1.1.0
 * - Removed requirement for fullstory on npm
 * - Removed code about hubs
 *
 * This integration creates a link from the Sentry Error to the FullStory replay.
 * It also creates a link from the FullStory event to the Sentry error.
 * Docs on Sentry SDK integrations are here: https://docs.sentry.io/platforms/javascript/advance-settings/#dealing-with-integrations
 */

class SentryFullStory {
  name = "SentryFullStory";
  id = "SentryFullStory";
  sentryOrg = "penfold";
  baseSentryUrl = "https://sentry.io";

  setupOnce() {
    if (!process.browser) return null;

    Sentry.addGlobalEventProcessor((event, hint) => {
      if (!window.FS) return event;

      // getCurrentSessionURL isn't available until after the FullStory script is fully bootstrapped.
      // If an error occurs before getCurrentSessionURL is ready, make a note in Sentry and move on.
      // More on getCurrentSessionURL here: https://help.fullstory.com/develop-js/getcurrentsessionurl
      event.contexts = {
        ...event.contexts,
        fullStory: {
          fullStoryUrl:
            window.FS.getCurrentSessionURL?.(true) ||
            "current session URL API not ready",
        },
      };

      let sentryUrl;
      try {
        // No docs on this but the SDK team assures me it works unless you bind another Sentry client
        const { dsn } = Sentry.getCurrentHub().getClient().getOptions();
        const projectId = util.getProjectIdFromSentryDsn(dsn);
        sentryUrl = `${this.baseSentryUrl}/organizations/${this.sentryOrg}/issues/?project=${projectId}&query=${hint.event_id}`;
      } catch (_err) {
        console.error("Error retrieving project ID from DSN");
        //TODO: Could put link to a help here
        sentryUrl = "Could not retrieve url";
      }

      // FS.event is immediately ready even if FullStory isn't fully bootstrapped
      window.FS.event("Sentry Error", {
        sentryUrl,
        ...util.getOriginalExceptionProperties(hint),
      });
      return event;
    });
  }
}

export default SentryFullStory;
